import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, InputNumber, Select, DatePicker, Switch, Card, Row, Col } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';

export const PromoCodeCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/promo-codes',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Yangi promo kod">
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Asosiy ma'lumotlar"
                  help="Promo kodning asosiy sozlamalari - kod, turi va qiymati"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label="Promo kod"
                    help="Foydalanuvchilar kiritadigan kod. Katta harflarda saqlanadi."
                  />
                }
                name="code"
                rules={[
                  { required: true, message: 'Promo kodni kiriting' },
                  { min: 3, message: "Kamida 3 ta belgi bo'lishi kerak" },
                ]}
              >
                <Input
                  placeholder="SAFARGO2024"
                  style={{ textTransform: 'uppercase' }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Turi"
                    help="FOIZ - sayohat narxidan foiz chegirma. QAT'IY SUMMA - aniq summa chegirma."
                  />
                }
                name="type"
                rules={[{ required: true, message: 'Turini tanlang' }]}
                initialValue="PERCENTAGE"
              >
                <Select
                  placeholder="Chegirma turini tanlang"
                  options={[
                    { value: 'PERCENTAGE', label: 'Foiz (%)' },
                    { value: 'FIXED_AMOUNT', label: "Qat'iy summa (so'm)" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Qiymat"
                    help="Foiz uchun: 10 = 10% chegirma. Summa uchun: 10000 = 10,000 so'm chegirma."
                  />
                }
                name="value"
                rules={[{ required: true, message: 'Qiymatni kiriting' }]}
              >
                <InputNumber
                  min={1}
                  style={{ width: '100%' }}
                  placeholder="10"
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Faol"
                    help="Promo kod ishlaydimi yoki yo'qmi"
                  />
                }
                name="isActive"
                valuePropName="checked"
                initialValue={true}
              >
                <Switch checkedChildren="Ha" unCheckedChildren="Yo'q" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Cheklovlar"
                  help="Promo koddan foydalanish cheklovlari"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label="Maksimal ishlatish soni"
                    help="Promo kod umumiy necha marta ishlatilishi mumkin. Bo'sh = cheklanmagan."
                  />
                }
                name="maxUsages"
              >
                <InputNumber
                  min={1}
                  style={{ width: '100%' }}
                  placeholder="100"
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Minimal sayohat summasi"
                    help="Promo kod ishlashi uchun sayohat narxi qancha bo'lishi kerak"
                  />
                }
                name="minTripAmount"
              >
                <InputNumber
                  min={0}
                  style={{ width: '100%' }}
                  placeholder="50000"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                  }
                  parser={(value) => Number(value?.replace(/\s/g, '') || 0)}
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Maksimal chegirma"
                    help="Foizli chegirma uchun maksimal summa. Masalan: 20% chegirma lekin maksimum 50,000 so'm."
                  />
                }
                name="maxDiscount"
              >
                <InputNumber
                  min={0}
                  style={{ width: '100%' }}
                  placeholder="50000"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                  }
                  parser={(value) => Number(value?.replace(/\s/g, '') || 0)}
                />
              </Form.Item>
            </Card>

            <Card
              title={
                <SectionTitle
                  title="Amal qilish muddati"
                  help="Promo kod qaysi sanadan qaysi sanagacha ishlaydi"
                />
              }
              style={{ marginTop: 24 }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label="Boshlanish sanasi"
                        help="Promo kod qaysi sanadan boshlab ishlaydi. Bo'sh = hozirdan."
                      />
                    }
                    name="startsAt"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Sanani tanlang"
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label="Tugash sanasi"
                        help="Promo kod qaysi sanada tugaydi. Bo'sh = cheklanmagan."
                      />
                    }
                    name="expiresAt"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Sanani tanlang"
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
